import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { registerLicense } from "@syncfusion/ej2-base";

import { environment } from "./environments/environment";
import {
  enableProdMode,
  APP_INITIALIZER,
  importProvidersFrom,
} from "@angular/core";
import { AppComponent } from "./app/app.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import {
  UserIdleConfig,
  UserIdleModule,
  WSSyncFusionGridConfig,
} from "wspowerpack";
import { ReactiveFormsModule } from "@angular/forms";
import { CoreModule } from "./app/modules/core/core.module";
import { ToastrModule } from "ngx-toastr";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { AuthService } from "./app/modules/core/services/auth.service";
import { Http500Interceptor } from "./app/modules/core/interceptors/Http500.interceptor";
import { AuthInterceptor } from "./app/modules/core/interceptors/auth.interceptor";
import {
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  provideHttpClient,
} from "@angular/common/http";
import { AuthorizationGuard } from "./app/modules/core/guards/authorization.guard";
import { DatePipe } from "@angular/common";
import { API_BASE_URL } from "./app/api/client";
import { APP_ROUTES } from "./app/app.routes";
import { provideRouter } from "@angular/router";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
const GRID_CONFIG: WSSyncFusionGridConfig = {
  apiRoot: environment.apiRoot + "/",
};

const userIdleConfig: UserIdleConfig = {
  idle: environment.idle,
  timeout: 30, //seconds
  ping: 120,
};

const appInitializerFn = (appConfig: AuthService) => {
  return () => {
    return appConfig.initializeApp();
  };
};

if (environment.production) {
  enableProdMode();
}
bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      ToastrModule.forRoot({
        positionClass: "toast-bottom-right",
      }),
      CoreModule,
      ReactiveFormsModule,
      UserIdleModule.forRoot({
        idle: environment.idle,
        timeout: 10,
        ping: 120,
      }),
      DragDropModule,
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      })
    ),

    [DatePipe],
    AuthorizationGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http500Interceptor,
      multi: true,
    },
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: UserIdleConfig,
      useValue: userIdleConfig,
    },
    {
      provide: WSSyncFusionGridConfig,
      useValue: GRID_CONFIG,
    },
    { provide: API_BASE_URL, useValue: environment.apiRoot },
    provideAnimations(),
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
// Registering Syncfusion license key
registerLicense(
  "ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9TdURiW39bdX1RQmJd"
);
